export const NVTECH_TOKEN_HASH_SALT = "P0WxaaXjWtxuSb4wQjRiiC7leBIu17lqN0I8lqZfmEKkwI0TVgRcEtQVINAsXgm_";
